import { get, post, patch, del } from './client.js';

export const list          = ()                 => get('/platform/users');
export const getOne        = (id)               => get(`/platform/users/${id}`);
export const updateRole    = (id, role)         => patch(`/platform/users/${id}`, { platformRole: role });
export const updateProfile = (id, body)         => patch(`/platform/users/${id}/profile`, body);
export const assignRole    = (id, customRoleId) => post(`/platform/users/${id}/assign-role`, { customRoleId });
export const forceLogout   = (id)               => post(`/platform/users/${id}/force-logout`);
// suspend / reactivate (backend endpoint: deactivate/activate; UI label: Suspend Access / Reactivate)
export const suspend       = (id)               => post(`/platform/users/${id}/deactivate`);
export const reactivate    = (id)               => post(`/platform/users/${id}/activate`);
export const deactivate    = suspend;   // backward compat alias
export const activate      = reactivate;
// Remove Access: clears both platform roles; does NOT delete the user record
export const removeAccess  = (id)               => del(`/platform/users/${id}`);
export const revoke        = removeAccess;      // backward compat alias
